import { Col, Expandable, Typography } from "@commonlibs";
import { Faq } from "common/models";
import { useState } from "react";
import ExpandableIcon from "../Expandable/ExpandableIcon/ExpandableIcon";
import { TermsAndConditionsLink } from "../../feedback/TermsAndConditions/TermsAndConditions.styles";
import { config } from "common/config";
import { URL_TITLES } from "ui/common/pages/HelpPage/HelpPage.constants";

export interface HelpItemProps {
    faq?: Faq;
}

function HelpItem({ faq }: HelpItemProps) {
    const [open, setOpen] = useState(false);

    const urlTitles: string[] = [URL_TITLES.termsAndConditions, URL_TITLES.personalDataTreatment, URL_TITLES.privacyPolicy];

    function getUrlHref(urlTitle: string): string {
        switch (urlTitle) {
            case URL_TITLES.termsAndConditions:
                return config.termsAndConditionsUrl;
            case URL_TITLES.personalDataTreatment:
                return config.personalDataTreatmentUrl;
            case URL_TITLES.privacyPolicy:
                return config.privacyPolicyUrl;
            default:
                return "";
        }
    }

    return (
        <div
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    if (faq?.title && !urlTitles.includes(faq?.title)) {
                        setOpen(!open);
                    }
                }
            }}
            onClick={() => {
                if (faq?.title && !urlTitles.includes(faq?.title)) {
                    setOpen(!open);
                }
            }}
            style={{ cursor: "pointer" }}
        >
            <Expandable open={open}>
                <Expandable.Display ExpandComponent={ExpandableIcon}>
                    <Col flex={1}>
                        <Typography variant={"body2Regular"} color={open ? "white" : "text"}>
                            {faq?.title}
                        </Typography>
                        {faq?.title && urlTitles.includes(faq?.title) ? (
                            <TermsAndConditionsLink href={getUrlHref(faq?.title)}>Ver aquí</TermsAndConditionsLink>
                        ) : (
                            !open && (
                                <Typography variant="body3Medium" light numberOfLines={1}>
                                    {faq?.description}
                                </Typography>
                            )
                        )}
                    </Col>
                </Expandable.Display>
                <Expandable.Body>
                    <Expandable.Content>
                        <Typography variant={"body3Medium"} color={"overlays.0.60"}>
                            {faq?.description}
                        </Typography>
                    </Expandable.Content>
                </Expandable.Body>
            </Expandable>
        </div>
    );
}

export default HelpItem;
